import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { RichTreeView, TreeItem2 } from '@mui/x-tree-view';
import { CheckboxUI } from '../Interface';
import { Typography } from '@mui/material';
import { sxConfig } from './ProductionGeneratorPartial.style';

const ProductionGeneratorPartialTree = ({
  sourceDataState,
  treeDataState,
  expandedItemsState,
  selectedItemState,
  removedItemState,
  selectedOrderState,
  newProdsState,
  prodsAndFromWhsState,
}) => {
  const { sourceData } = sourceDataState;
  const { treeData } = treeDataState;
  const { expandedItems, setExpandedItems } = expandedItemsState;
  const { setSelectedItem } = selectedItemState;
  const { setRemovedItem } = removedItemState;
  const { selectedOrder } = selectedOrderState;
  const { newProds } = newProdsState;
  const { prodsAndFromWhs } = prodsAndFromWhsState;

  const [checkedState, setCheckedState] = useState([]);

  const generateKey = (findedItem) => {
    if (!findedItem) return '';
    return `${findedItem.variantMainItemCode ?? findedItem.rootItemCode}_${findedItem.level === 1 ? findedItem.relatedItemCode : findedItem.parentItemCode}_${findedItem.relatedItemCode}_${findedItem.level}`;
  };

  const generateKeyFromProd = (prodItems) => {
    return prodItems.map(
      (prodItem) =>
        `${prodItem.finishedItemCode}_${prodItem.variantFinishedItemCode}_${prodItem.variantItemCode}_${prodItem.level}`
    );
  };

  useEffect(() => {
    if (!sourceData.length) return;
    const filteredProds = newProds.filter(
      (prod) =>
        prod.baseDocType === selectedOrder.docTypeId &&
        prod.baseId === selectedOrder.docId &&
        prod.baseLine === selectedOrder.lineNum
    );

    const inNewprodTable = generateKeyFromProd(filteredProds);

    setCheckedState([...inNewprodTable]);
    // itt kell majd kezelni, ha van már hozzá gyártás vagy raktárról
  }, [sourceData]);

  const handleExpandedItemsChange = (event, itemIds) => {
    setExpandedItems(itemIds);
  };

  const getItemLabel = (item) => {
    return `${item.relatedItemCode} - ${item.relatedItemName} ${item.variantNote ? `|| ${item.variantNote}` : ''}`;
  };

  const addSelection = (findedItem) => {
    const key = generateKey(findedItem);
    setCheckedState((prev) => [...prev, key]);
    setRemovedItem(null);
    setSelectedItem(findedItem);
  };

  const removeSelection = (findedItem) => {
    const key = generateKey(findedItem);
    setCheckedState((prev) => prev.filter((k) => k !== key));
    setRemovedItem(findedItem);
  };

  const computeLabelColor = ({ checked, hasWarehouse, hasProduction, hasOps }) => {
    if (checked) return 'success.main';
    if (hasWarehouse) return 'warning.main';
    if (hasProduction) return 'warning.main';
    if (!hasOps) return 'red';
    return '';
  };

  const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const findedItem = sourceData.find((item) => {
      return item.id === props.itemId;
    });
    const key = generateKey(findedItem);

    const findedItemSourceList = findedItem?.sourceList ?? {};
    const findedItemSourceListOp = findedItemSourceList?.sourceListOperation ?? [];

    const checked = checkedState.includes(key);

    const finishedItemCode = findedItem?.variantMainItemCode ?? findedItem?.rootItemCode;

    const hasProduction = prodsAndFromWhs.production.some(
      (prod) =>
        prod.articleNumber === (findedItem?.relatedvariantItemCode ?? findedItem?.relatedItemCode) &&
        prod.level === findedItem?.level &&
        prod.finishedItemCode === finishedItemCode &&
        prod.variantItemCode === findedItem.relatedItemCode &&
        prod.variantFinishedItemCode ===
          (findedItem.level === 1 ? findedItem.relatedItemCode : findedItem.parentItemCode)
    );

    const hasWarehouse = prodsAndFromWhs.fromWarehouse.some(
      (fromWhs) =>
        fromWhs.itemCode === (findedItem?.relatedvariantItemCode ?? findedItem?.relatedItemCode) &&
        fromWhs.variantItemCode === findedItem.relatedItemCode &&
        fromWhs.mainItemCode === (findedItem.level === 1 ? findedItem.relatedItemCode : findedItem.parentItemCode)
    );

    // variánsokhoz majd lehet, hogy kell
    /*const anyOtherCheckedSameLevel =
      !!findedItem &&
      checkedState.some((k) => {
        if (k === key) return false;
        const levelFromKey = parseInt(k.split('_').pop(), 10);
        return levelFromKey === findedItem.level;
      });*/
    //const levelLocked = anyOtherCheckedSameLevel && !checked;

    const disabled = hasProduction || hasWarehouse;

    const hasOps = Object.keys(findedItemSourceList).length > 0 && findedItemSourceListOp.length > 0;
    const labelColor = computeLabelColor({ checked, hasWarehouse, hasProduction, hasOps });

    return (
      <TreeItem2
        {...props}
        ref={ref}
        disabled={disabled}
        label={
          <Box sx={{ color: labelColor, ...sxConfig.checkBoxMainBox }}>
            <CheckboxUI
              onClick={(event) => event.stopPropagation()}
              checked={checked}
              disabled={disabled}
              size="small"
              onChange={(e) => {
                if (!findedItem || disabled) return;
                if (e.target.checked) addSelection(findedItem);
                else removeSelection(findedItem);
              }}
              sx={sxConfig.checkBox}
            />
            <Typography>{props.label}</Typography>
          </Box>
        }
      />
    );
  });
  return (
    <Box sx={sxConfig.richTreeView}>
      <RichTreeView
        items={treeData}
        getItemLabel={getItemLabel}
        expandedItems={expandedItems}
        onExpandedItemsChange={handleExpandedItemsChange}
        slots={{
          item: CustomTreeItem,
        }}
      />
    </Box>
  );
};

export default ProductionGeneratorPartialTree;
